// Explicit preauth credentials must win over a previous session in localStorage.
export function attachSessionToken(config, token) {
  config.headers = config.headers || {};
  if (token && !config.headers.Authorization && !config.headers.authorization) {
    config.headers.Authorization = token;
  }
  return config;
}
